import React from 'react';
import PropTypes from 'prop-types';
import { SketchPicker, CirclePicker } from 'react-color';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const styles = {
  paper: {
    width: 192,
    height: 48,
    margin: 'auto',
  },
  picker: {
    margin: '12px auto 0',
  },
};

const SetColors = ({ onChangeComplete, color, classes, useCirclePicker }) => (
  <React.Fragment>
    {useCirclePicker ? (
      <div>
        <CirclePicker
          color={color}
          onChangeComplete={object => onChangeComplete(object.hex)}
          className={classes.picker}
        />
        <div
          style={{
            fontSize: 16,
            fontFamily: 'Roboto',
            maxWidth: 200,
            textAlign: 'center',
            margin: '24px auto 0',
          }}
        >
          Note: This is just to help get you started. You can fine tune your
          colors later.
        </div>
      </div>
    ) : (
      <div>
        <Paper className={classes.paper} style={{ backgroundColor: color }}>
          &nbsp;
        </Paper>
        <SketchPicker
          disableAlpha
          color={color}
          onChangeComplete={object => onChangeComplete(object.hex)}
          className={classes.picker}
        />
      </div>
    )}
  </React.Fragment>
);

SetColors.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  onChangeComplete: PropTypes.func.isRequired,
  useCirclePicker: PropTypes.bool.isRequired,
};
SetColors.defaultProps = {
  useCirclePicker: false,
};

export default withStyles(styles)(SetColors);
